export default {"src":"/reise/pakkereiser/_next/static/media/tf.50570d39.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};